import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  draft: "bg-amber-50 text-amber-800 border-amber-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  rejected: "bg-rose-50 text-rose-800 border-rose-200",
  voided: "bg-slate-100 text-slate-700 border-slate-300",
  Balanced: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Unbalanced: "bg-rose-50 text-rose-800 border-rose-200",
  "Awaiting Approval": "bg-amber-50 text-amber-800 border-amber-200",
  Approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Voided: "bg-slate-100 text-slate-700 border-slate-300",
  Rejected: "bg-rose-50 text-rose-800 border-rose-200",
  "No Invoices": "bg-slate-50 text-slate-500 border-slate-200",
};

export function StatusBadge({ status, testId }) {
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-300";
  const label = typeof status === "string" ? status.charAt(0).toUpperCase() + status.slice(1) : String(status);
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${style}`}
    >
      {label}
    </span>
  );
}
